<template>
    <div>
        <div class="question-actions">
            <SurveyHistory
                v-if="event.modified_time"
                :id="event.id"
                :event="event"
                :patient="patient"
                :question="question">
            </SurveyHistory>
            <el-button class="edit-button" @click="$emit('open-dialog')">
                <EditSurveyIcon></EditSurveyIcon>
            </el-button>
        </div>
        <el-dialog :append-to-body="true"
            class="send-now-modal edit-question-modal"
            :visible.sync="showEdit"
            :close-on-click-modal="false"
            :before-close="handleClose">
            <span slot="title"> Edit answer </span>
            <div class="question-title">
                {{qNum + "."}} {{ question.title }} <span class="question-content">({{ question.question }})</span>
            </div>
            <slot></slot>
            <div class="footer">
                <div class="remove-response" v-if="showRemoveResponse">
                    <RemoveResponseIcon></RemoveResponseIcon>
                    <span @click="$emit('response-removed')">Remove Response</span>
                </div>
                <div class="mandatory-quest" v-if="isMandatory"> 
                    <span>
                        * Mandatory
                    </span>
                </div>
                <el-button type="text" size="small" class="cancel-button" @click="$emit('close-dialog')">
                    Cancel
                </el-button>
                <LoadingButton
                        type="primary"
                        size="small"
                        class="send-button"
                        :disabled="saveDisabled"
                        @click="$emit('save-edit')"
                        :loading="savingEdit">
                    Save
                </LoadingButton>
                </div>
        </el-dialog>
    </div>
</template>

<script>
import LoadingButton from '@/module/component/LoadingButton'
import SurveyHistory from '../SurveyHistory'
import Icons from '../analysis/response/icon'

export default {
    name: 'edit-base',

    props: {
        question: {
            type: Object
        },
        event: {
            type: Object
        },
        survey: {
            type: Object
        },
        patient: {
            type: Object
        },
        savingEdit: {
            type: Boolean,
            default: false
        },
        showEdit: {
            type: Boolean,
            default: false
        },
        saveDisabled: {
            type: Boolean,
            default: false
        },
        qNum: {
            type: Number
        },
        showRemoveResponse: {
            type: [Boolean, Array, Object]
        },
        isMandatory: {
            type: Boolean
        }
    },

    methods: {
        handleClose() {
            this.$emit('close-dialog')
        }
    },

    components: {
        ...Icons,
        LoadingButton,
        SurveyHistory
    }
}
</script>

<style lang="scss">
@import './style.scss';
</style>
